import React from 'react';
import { Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import DashboardPageLayout from 'src/frontend-common/components/DashboardPageLayout';
import { useGetFeatureAnalysisResultQuery } from 'src/redux/services/imports';
import FeatureImportance from 'src/pages/FeatureAnalysis/FeatureImportance';
import RuleRaccomendations from 'src/pages/FeatureAnalysis/RuleRaccomedations';
import { IAlertAnalytic } from 'src/frontend-common/dto/Interfaces/Analytics';
import EmptyState from 'src/frontend-common/components/EmptyState';
import UploadDetailsTable from 'src/pages/FeatureAnalysis/UploadDetailsTable';
import InsightsCustomTabs from 'src/pages/FeatureAnalysis/InsightsCustomTabs';
import AccuracyAnalysis from 'src/pages/FeatureAnalysis/AccuracyAnalysis';
import { KoPercentagePerValue } from 'src/pages/FeatureAnalysis/FeatureAnalysisTypes';

export interface IFileDetails {
  original_file_name: string;
  file_upload_time: string;
  n_records: number;
  n_errors: number;
  n_matching_ids: number;
  n_missing_ids: number;
  created_at: string;
  ok_label_details: string;
  ko_label_details: string;
}

const FeatureAnalysis: React.FC = () => {
  const [verticalBarChartData, setVerticalBarChartData] = React.useState<IAlertAnalytic[]>();
  const [featureDistributionPerClass, setFeatureDistributionPerClass] = React.useState<{
    true?: { ko: number; ok: number };
    false?: { ko: number; ok: number };
  }>();

  const [koDataArray, setKoDataArray] = React.useState<KoPercentagePerValue | undefined>();
  const [productLabels, setProductLabels] = React.useState<string[]>();
  const [featureImportanceChart, setFeatureImportanceChart] = React.useState<number>(0);
  const [featureNames, setFeatureNames] = React.useState<string[]>();
  const [featureName, setFeatureName] = React.useState<string>();
  const [product, setActiveProduct] = React.useState<string>();
  const [activeTab, setActiveTab] = React.useState<number>(0);
  const [fileDetails, setFileDetails] = React.useState<IFileDetails | undefined>();

  const id = useParams<{ id: string }>();
  const { data: dataAnalysis, isError: isErrorDataAnalysis, isLoading: isLoadingDataAnalysis } = useGetFeatureAnalysisResultQuery({ id: id.id || '' });

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  return (
    <DashboardPageLayout title="Insight">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <UploadDetailsTable fileDetails={fileDetails} />
        </Grid>
        <Grid item xs={12}>
          <InsightsCustomTabs featureImportanceChart={featureImportanceChart} setFeatureImportanceChart={setFeatureImportanceChart} a11yProps={a11yProps} />
        </Grid>

        {featureImportanceChart === 0 && (
          <AccuracyAnalysis
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            a11yProps={a11yProps}
            dataAnalysis={dataAnalysis}
            isErrorDataAnalysis={isErrorDataAnalysis}
            isLoadingDataAnalysis={isLoadingDataAnalysis}
            setFileDetails={setFileDetails}
            setProductLabels={setProductLabels}
            setVerticalBarChartData={setVerticalBarChartData}
            setKoDataArray={setKoDataArray}
            setActiveProduct={setActiveProduct}
            setFeatureName={setFeatureName}
          />
        )}
        {featureImportanceChart === 1 && (
          <FeatureImportance
            dataAnalysis={dataAnalysis}
            verticalBarChartData={verticalBarChartData}
            product={product}
            productLabels={productLabels}
            setActiveProduct={setActiveProduct}
            featureDistributionPerClass={featureDistributionPerClass}
            setFeatureDistributionPerClass={setFeatureDistributionPerClass}
            koDataArray={koDataArray}
            setKoDataArray={setKoDataArray}
            featureNames={featureNames}
            featureName={featureName}
            setFeatureName={setFeatureName}
            setFeatureNames={setFeatureNames}
            a11yProps={a11yProps}
          />
        )}

        {featureImportanceChart === 2 && (dataAnalysis?.item ? <RuleRaccomendations appKey={dataAnalysis.item.app_key} /> : <EmptyState />)}
      </Grid>
    </DashboardPageLayout>
  );
};

export default FeatureAnalysis;
